import {createContext, useContext} from 'react';

export const DepartmentContext = createContext();

export function useDepartmentContext() {
  return useContext(DepartmentContext);
}
